import * as R from 'ramda';
import styled from 'styled-components';
import {
  space,
  color,
  layout,
  border,
  flexbox,
  position,
  typography,
} from 'styled-system';
// helpers/constants
import * as G from '../../helpers';
//////////////////////////////////////////////////

export const Text = styled.div`
  ${space}
  ${color}
  ${layout}
  ${border}
  ${flexbox}
  ${position}
  ${typography}

  cursor: ${({ cursor }) => cursor};
  word-break: ${({ wordBreak }) => wordBreak || 'unset'};
  white-space: ${({ whiteSpace }) => whiteSpace || 'nowrap'};
  text-decoration: ${({ textDecoration }) => textDecoration};
  text-transform: ${({ textTransform }) => R.or(textTransform, 'unset')};
  text-overflow: ${({ withEllipsis }) => G.ifElse(G.isTrue(withEllipsis), 'ellipsis', 'clip')}
`;

Text.defaultProps = {
  minWidth: 'unset',
  maxWidth: 'unset',
  display: 'inline',
  overflow: 'hidden',
  textAlign: 'unset',
  fontWeight: 'unset',
};
